import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgxBraintreeModule } from 'ngx-braintree';
import { HttpClientModule } from '@angular/common/http';

import { PaymentRoutingModule } from './payment-routing.module';
import { PaymentComponent } from './payment.component';

@NgModule({
  declarations: [PaymentComponent],
  imports: [
    CommonModule,
    PaymentRoutingModule,
    NgxBraintreeModule,
    HttpClientModule
  ]
})
export class PaymentModule { }
